import { workflowHistoryEntry } from "./workflow-document-pattern.js";
const isRecord = (value) => !!value && typeof value === "object" && !Array.isArray(value);
/** A source's name as a reviewer reads it: the connector, when known, and the entity read ("Xero bill lines"). */
function sourceLabel(source, connector) {
    const entity = source.kind === "connector_entity" ? source.entity.replaceAll("_", " ") : "records";
    return connector ? `${connector} ${entity}` : entity.charAt(0).toUpperCase() + entity.slice(1);
}
/**
 * The counterparty history a run's reads found: one entry per read that asks for a pattern and returned one,
 * taken from the run's node outputs (`{ effects: { [effectKey]: { pattern } } }`), accepted sign-offs first.
 * `connector` names a connector source's integration as people know it ("Xero"), when the caller can say.
 */
export function workflowRunHistory(definition, outputs, connector = () => undefined) {
    const effects = new Map(definition.effects.map((effect) => [effect.key, effect]));
    const entries = [];
    for (const output of outputs) {
        if (!isRecord(output) || !isRecord(output.effects))
            continue;
        for (const [key, read] of Object.entries(output.effects)) {
            const effect = effects.get(key);
            if (!effect || (effect.kind !== "source_read" && effect.kind !== "review_history") || !effect.pattern ||
                !isRecord(read) || !isRecord(read.pattern))
                continue;
            const source = effect.kind === "source_read"
                ? definition.sources.find((candidate) => candidate.key === effect.sourceKey) : undefined;
            // A retained pattern comes back from Postgres with its keys in its own order; a line reads in the
            // pattern's key order (account, then tax type).
            const pattern = read.pattern;
            const order = effect.pattern.keyFields;
            const ordered = pattern.established ? { ...pattern, established: { ...pattern.established,
                    lines: pattern.established.lines.map((line) => ({ ...line, keys: Object.fromEntries(order
                            .filter((field) => Object.hasOwn(line.keys, field)).map((field) => [field, line.keys[field]])) })) } } : pattern;
            entries.push(workflowHistoryEntry(key, ordered, {
                basis: effect.kind === "review_history" ? "signoffs" : "source",
                sourceLabel: source ? sourceLabel(source, source.kind === "connector_entity" ? connector(source.integrationId) : undefined) : null,
                ...(effect.pattern.minDocuments ? { minDocuments: effect.pattern.minDocuments } : {})
            }));
        }
    }
    return entries.sort((a, b) => Number(b.basis === "signoffs") - Number(a.basis === "signoffs"));
}
